import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'app-filter-panel',
    templateUrl: './filter-panel.component.html',
    styleUrls: ['./filter-panel.component.css'],
    standalone: false
})
export class FilterPanelComponent {
  private readonly defaultFileTypes = ['All', 'Core', 'NonCore', 'eseries', 'eseriesCore']
  private _fileTypes = ['All', 'Core', 'NonCore', 'eseries', 'eseriesCore']

  @Input()
  set fileTypes(value: string[]) {
      this._fileTypes = [...this.defaultFileTypes]
  }
  get fileTypes(): string[] {
    return this._fileTypes
  }

  @Output()
  whenFilter = new EventEmitter()

  startDateCtrl = new UntypedFormControl('');
  endDateCtrl = new UntypedFormControl('');
  caseNumberCtrl = new UntypedFormControl('');
  fileNameCtrl = new UntypedFormControl('');
  maskedFileNameCtrl = new UntypedFormControl('');
  fileTypeCtrl = new UntypedFormControl('All');
  constructor(private util: UtilsService) {
    // Set default dates: from 6 months ago to today
    const today = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(today.getMonth() - 6); // Subtract 6 months

    this.startDateCtrl.setValue(this.formatDate(sixMonthsAgo));
    this.endDateCtrl.setValue(this.formatDate(today));
  }

  private formatDate(date: Date): string {
    // Format the date to YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private getFilterParam(): any {
    return {
      startDate: this.util.parseDateWithoutTime(this.startDateCtrl.value),
      endDate: this.util.parseDateWithoutTime(this.endDateCtrl.value),
      caseNumber: this.caseNumberCtrl.value.trim(),
      fileName: this.fileNameCtrl.value.trim(),
      fileType: this.fileTypeCtrl.value && this.fileTypeCtrl.value !== "All" ? this.fileTypeCtrl.value : null,
      maskedFileName: this.maskedFileNameCtrl.value?.trim()
    }
  }

  private validate(): boolean {
    return !this.invalidStartEndDate
  }

  filter(): void {
    if (this.validate()) {
      this.whenFilter.emit(this.getFilterParam())
    }
  }

  get invalidStartEndDate(): boolean {
    const startDate = this.util.parseDateWithoutTime(this.startDateCtrl.value)
    const endDate = this.util.parseDateWithoutTime(this.endDateCtrl.value)
    return !!(startDate && endDate && startDate > endDate)
  }
}
